import { render, staticRenderFns } from "./ModalEventosCurrier.vue?vue&type=template&id=fceccb6e&scoped=true&"
import script from "./ModalEventosCurrier.vue?vue&type=script&lang=ts&"
export * from "./ModalEventosCurrier.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEventosCurrier.vue?vue&type=style&index=0&id=fceccb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceccb6e",
  null
  
)

export default component.exports